import { Outlet } from "react-router-dom";
import PageDepth2 from "../components/PageDepth2";
import styles from '../styles/Info.module.css';
import data from '../data/data.json'
import classNames from "classnames/bind";
import PageTitle from '../components/PageTitle';

const cx = classNames.bind(styles);

//손해사정 안내
export default function Info() {

  const InfoCategory = data.category.find(
    (category) => category.path === "info"
  )

  return (
    <>
      <PageTitle title={InfoCategory.label} image={InfoCategory.image} />

      <PageDepth2 pagedepth2={InfoCategory.children} />

      <Outlet/>
    </>
  );
}

